module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre8"
  }, [_vm._v("Erste Szene")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Das Höfchen des Bauern Helmbrecht. Links das Haus,\nin Stall und Wohnraum geteilt, mit Flurtür und Stalltür sowie zwei\nkleinen Fenstern der Wohnstube. Gegenüber ein kleiner Stadel mit\nHolzschuppen. Das Höfchen ist von der Straße im Hintergrunde durch\neinen Staketenzaun abgetrennt. Nahe dem Zaun ein Holzstoß. Das\nZaunpförtchen ist offen. Ein schöner Apfelbaum, die hängenden\nZweige mit einer Last roter Äpfel beschwert, überwölbt es. Den\nHintergrund bilden Bergwiesen, Wälder und leichtbeschneite\nHöhenzüge. Unweit der Haustür fließendes Wasser, in einen Steintrog\nplätschernd. Ein Pflug steht mitten im Hof.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Vater Helmbrecht, über die Fünfzig, sitzt auf der\nErde und dengelt die Sense. Er ist ein zähes, äußerst dürftiges\nBäuerlein von der menschenfreundlichen Sorte. Sein Scheitel ist\nsilberweiß und so auch der Bart, der von Ohr zu Ohr unterm Kinn\nherumgeht und das sonst bartlose Antlitz umrahmt.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Mutter Helmbrecht sitzt auf der Hausschwelle und\nläßt die Spindel tanzen. Die etwa fünfundvierzigjährige Frau haben\nSorge, Arbeit und Krankheit zu früh altern lassen.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Griselda, Tochter dieser beiden, ist eine\nungewöhnlich schöne und stattliche zwanzigjährige Bauernmagd, eine\nwahre Gudrungestalt. Barfuß, im kurzen Rock und bunten Mieder,\nschiebt sie eine Radwer"), _c('a', {
    staticClass: "pcalibre3 pcalibre pcalibre1 pcalibre2",
    attrs: {
      "href": "#/Text/#annotation1",
      "id": "textAnno1"
    }
  }, [_c('sup', {
    staticClass: "calibre9"
  }, [_vm._v("A1")])]), _vm._v(" mit Grummet vor sich her, die sie vor\nder Stalltür absetzt.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Es ist ein sonniger Morgen im Herbst.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(". Nu jeja, man wird\nalt. Vor zehn Jahren war ich noch jünger, Mutter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Je schwächer der\nBettler, je stärker die Krücke.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(". Betteln und\narbeiten ist noch immer zweierlei, Mutter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Griselda, federe\ndich. Du mußt hernach noch vier Mandeln Eier aufs Vorwerk\ntragen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("kurz,\nunfreundlich.")]), _vm._v(" Ich arbeite, was ich kann, Mutter.\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Sie hebt eine Kleelast und trägt sie in den\nStall.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(". Was soll bloß der\nalte Rodewinkel alles hergeben?! Mehr Zins als Frucht!")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Griselda kommt wieder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Griselda! "), _c('a', {
    staticClass: "pcalibre3 pcalibre pcalibre1 pcalibre2",
    attrs: {
      "id": "page8",
      "title": "joe_ebc/Pirki"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Schon wieder was!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Könnt' ich mir\nhelfen, braucht' ich dich nicht zu rufen, Mädel. Was hat's denn mit\ndir? Du bist doch sonst nicht so bösartig gewesen mit deiner\nMutter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Man möchte wohl bösartig\nsein in der Welt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Warum denn?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Warum? Darum! Warum, hat\nschon mancher gefragt. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Sie trägt wiederum eine\nKleelast in den Stall.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("tritt mit der Sense vor die Stalltür und spricht\nhinein.")]), _vm._v(" Nanu jetzt . . . nanu, jetzt hab' ich dir also . . .\nhätt' ich dir also die Sense scharf gemacht. Morgen beizeiten . . .\nalso bei guter Zeit, Mädel, haun wir den letzten Fleck Grummet\nhinten im Schindelgrunde los.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Griselda kommt wieder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Morgen is Sonntag.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(", 's Grummet muß\nrein, wenn auch Sonntag is.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Nu Mädel! Nee\nMädel! Jetzt sag mir bloß! Du bist doch sonst nich so auf das\nKirchelaufen versessen gewesen. Hat dir etwa der neue Kaplan den\nKopf verwirrt?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(". Mag sein, daß ein\nMädel in deinem Alter Gedanken hat. Was nutzt das? Dawider hilft\nnichts wie arbeiten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Ich denke, meine Hände\nsind hart genug.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(". Das Gras muß los.\nUnser Herrgott wird ein Einsehen haben. Es tröpfelt. Nächste Woche\nschneit's womöglich. Unser Herrgott wird besser wissen als du, was\nViehwirtschaft is. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Er geht ins Haus.")])]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Ein Mann, in der Tracht eines Tagelöhners oder\nWaldhüters, blickt über den Zaun.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("mit\nfunkelnden Augen unter buschigen Brauen.")]), _vm._v(" Na, was keift die\nAlte schon wieder mal?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("schrickt zusammen, bemerkt den Fremden.")]), _vm._v(" Wie?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(". Ob die alte Urschel das\nKeifen nicht lassen kann, frag' ich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("konsterniert.")]), _vm._v(" Wer seid Ihr denn?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(". Ach was, das kann dir\nso gleich sein wie mir! Kann man bei euch einen Schluck Wasser\nhaben?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("mit\nbeiläufiger Kopfbewegung gegen den Röhrenbrunnen.")]), _vm._v(" Dort hat's\nWasser genug.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(". Warum so von oben\nherab, schöne Roggenmuhme? "), _c('a', {
    staticClass: "pcalibre3 pcalibre pcalibre1 pcalibre2",
    attrs: {
      "id": "page9",
      "title": "joe_ebc/Pirki"
    }
  }), _vm._v(" Kann man vielleicht eine Topfscherbe haben, um\ndaraus zu trinken?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Mädel, gleich\nhinter der Tür steht ein Tassenkopp.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Ich hab' keine Zeit, ich\nhab' andres zu tun.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(". Warum denn so unhold,\nerhabenste Kuhprinzessin, sage mir doch?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Ihr mögt vielleicht ein\nKuhprinz sein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("ist\nsehr gelassen eingetreten und hat sich ebenso auf den Pflug\ngesetzt.")]), _vm._v(" Gut geantwortet. – Wie alt bist du?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Wenn Ihr getrunken habt,\nkönnt Ihr Eurer Wege gehn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("unbeirrt.")]), _vm._v(" Wie alt bist du?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Nicht mehr jung genug, um\nmit jedem hergelaufnen Tagedieb Dummheiten zu schwatzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("unbeirrbar gelassen.")]), _vm._v(" Deine Mutter muß in einem\nreifen Weizenfelde geschlafen haben, als dein Vater dich\nmachte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("traut\nihren Ohren nicht, dann auf ihn los.")]), _vm._v(" Pack dich! Du bist ein\nSchweinehund! Geh!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("wie\nvorher.")]), _vm._v(" Das ist mir schon von viel häßlicheren Frauenzimmern\ngesagt worden, als du eins bist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("etwas\naus der Fassung.")]), _vm._v(" – Du bist aus einem Tollhaus\nentsprungen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("hartnäckig.")]), _vm._v(" Und du in einem reifen Kornfelde\ngemacht.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Griselda ergreift eine Schaufel, kehrt sie um und\ngeht auf den Fremden los.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Griselda! Du\nbist nicht bei Sinnen, Mädel!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("ein\nwenig bleich, sonst vollkommen gleichmütig.")]), _vm._v(" Schlag! – Warum\nschlägst du nicht? – Ich möchte grade von einem solchen\nFrauenzimmer, mit solcher Stirne, mit solcher Brust, mit solchen\nHüften und mit einer solchen Korngarbe im Nacken, erschlagen\nwerden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("abermals und aufs höchste konsterniert, wirft die Schaufel\nweg.")]), _vm._v(" Oh, ich hätte wahrhaftig Besseres zu tun, als auf deine\nhirnverbrannten Reden zu passen. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Sie schiebt\ndie Radwer in den Holzstall und betätigt sich.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("ist, den Fremden scharf und nachdenklich im Auge behaltend,\nden Vorgängen gefolgt.")]), _vm._v(" Vater! Vater! Es is jemand hier.\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre pcalibre1 pcalibre2",
    attrs: {
      "id": "page10",
      "title": "joe_ebc/Pirki"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(". Liebst du Goldstücke,\nAlte? "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Er wirft ihr einige in den\nSchoß.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Vater! – Das\ngeht nich mit rechten Dingen zu! – Vater! – Was is das? –\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Sie streicht die Münzen von der Schürze.")]), _vm._v("\nStehlen und betteln brauchen wir nich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("unbeirrt zu Griselda.")]), _vm._v(" Willst du aufs Feld?\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Griselda hat das Joch eines Zugochsen vom\nTürpfosten genommen und antwortet nicht.")]), _vm._v(" Willst du die Kuh\nvor den Pflug spannen? – "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Mit eigentümlichem\nNachdruck, heiß.")]), _vm._v(" Laß doch das Rind, du junge Färse, im\nStall: spanne dich selbst vor den Pflug! Ich werde die Sterzen\nhalten und die goldenen Zügel deines Haares um meine Fäuste\nwickeln. – Willst du?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Ich habe auch Fäuste.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("hartnäckig.")]), _vm._v(" Ich werde die Stränge und Stricke und\nSeile deiner Haare mit Knoten versehen, und du sollst zittern unter\nmeiner Geißel – du junges Rind!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("packt\nden Fremden vor der Brust und stößt ihn durchs Zaunpförtchen\nhinaus.")]), _vm._v(" Pack dich! so! pack dich! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Sie\nkommt in den Hof zurück und schließt das Pförtchen.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("sehr bleich, hebt die Mütze auf, die ihm entfallen\nist.")]), _vm._v(" Nicht übel! – Du gefällst mir! – "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Griselda steht an der Schuppentür und weint still in die\nSchürze. Der Fremde schlendert, die Hände in den Taschen, langsam\nwiederum in den Hof.")]), _vm._v(" Was kostet bei euch ein Trunk Wasser,\nAlte?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Ich hab' all\nmein Lebtag dem armen Wandrer seinen Schluck Wasser gegönnt. Was\nIhr wollt, mag wohl was andres sein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(". Seid ihr leibeigen oder\nFronbauern? Steht ihr dem Kloster oder der Herrschaft zu?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Ich denke, das\nkann Euch wenig bekümmern, wem wir zustehn! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ins\nHaus rufend:")]), _vm._v(" Mann! – Trinkt und geht Eurer Wege, wer Ihr\nauch seid! – Mann! Mann! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Vater Helmbrecht\nerscheint in der Haustür.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(". Was schreist du\ndenn, Mutter?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(". Die Weiber schreien,\nweil ich durstig bin! – Was? Ist Er nicht der alte Helmbrecht, der\nnachts zu meines seligen Herrn Vaters Zeiten mit dem greulichen\nTutehorn winters und sommers bei Regen, Wind und Mondschein die\nWache hatte? Ist Er nicht der Nachtwächter Helmbrecht von Jagdhaus\nSchönbuche, dem wir jungen Leute einmal nach einem etwas\nausgelassenen Jagdschmause "), _c('a', {
    staticClass: "pcalibre3 pcalibre pcalibre1 pcalibre2",
    attrs: {
      "id": "page11",
      "title": "joe_ebc/Pirki"
    }
  }), _vm._v(" den Streich spielten, im eigenen Schlößchen\neinzubrechen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(". Jawohl, der soll\nich wohl immer noch sein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Fremde")]), _vm._v(". Weißt du, wer ich\nbin?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(". Auch immer noch\nunser Markgraf Ulrich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". I, du großer\nGott: ich hab' ja den gnädigen Herrn auf der Stelle erkannt!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Graf Ulrich")]), _vm._v(". Davon hast du aber\nnichts merken lassen. Ich will mir den Bart scheren lassen und\nMandelkleie in mein Waschwasser nehmen, damit ich wieder wie einer\nvon jenen Zieraffen aussehe, die euch in Respekt versetzen. Wie\ngeht's sonst, alter Nachtwächter! Jetzt machst du wieder dein\nVaterunsergesicht. Kannst du auch noch deine dreimal gehängte\nDiebsvisage aufstecken?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(". Je nachdem, Herr!\nObgleich ich das nicht mehr so nötig habe, seit der alte\nFreihubener Bauer, der soviel als der Vater von meinem Weibe war,\ngestorben ist und wir das Waldgut hier oben geerbt haben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Graf Ulrich")]), _vm._v(". Ach so! Deshalb hat\nmir auch dein Teufel von Tochter alle Rippen im Leibe\nzerbrochen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Griselda, tu\nAbbitte!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Graf Ulrich")]), _vm._v(". Laß sie! Mich ficht's\nnicht an! Will heißen, ich leide, weiß Gott, keine Anfechtungen\nihrethalb! Was hat sie sich also so ungebärdig, da sie doch niemand\ndressieren will. Will ich Fuchsjagden reiten, so stehen in meinem\nMarstall Stuten genug. Und läge mir dran, grade bei diesem Satan\nmein Jus zu nehmen, es würde mich nur vier Worte kosten: schick sie\naufs Schloß! – und es wäre geschehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("kratzt sich hinterm Ohr.")]), _vm._v(" Schon, gnädiger Herr! Wenn\neiner nur jetzt nicht ein freier Feudaster geworden wäre.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Graf Ulrich")]), _vm._v(". Der Tausend, du\nSchlingel! Was bist du geworden?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(". Was leider Gottes\nnach dem Recht von Mailand bis Bern, von Bern bis Raben nicht mehr\nzu ändern ist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Graf Ulrich")]), _vm._v(". Höre: baue getrost\ndeinen Kohl, ich störe dich nicht. Behalte auch meinethalben deine\nanderthalb ranzigen Zinshühner! – Befiehl, sie soll mir in\nirgendeiner "), _c('a', {
    staticClass: "pcalibre3 pcalibre pcalibre1 pcalibre2",
    attrs: {
      "id": "page12",
      "title": "joe_ebc/Pirki"
    }
  }), _vm._v("\nScherbe einen Trunk Wassers reichen, sonst nichts! Das sei ihr\nganzer Gehorsam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Griselda, reiche\ndem gnädigen Herrn Markgrafen Wasser, im Augenblick!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Nein!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(".\nKotzschockschwerenotmillionschwerebrett!!")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Griselda nimmt eine Milchgelte und begibt sich mit\ntrotzigem Entschluß an den Brunnen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Graf Ulrich")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("mit gekünsteltem Gleichmut zu Helmbrecht.")]), _vm._v(" Habt Ihr\ngehört, daß heuer unten am See die Weinbauern recht sehr übel\nabschneiden?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("erst mit einem Blick auf Griselda.")]), _vm._v("\nSchwerenotskotzhimmelschlag noch mal! – Auch die Oliven sind\nschlecht geraten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Graf Ulrich")]), _vm._v(". Und außerdem auch die\nJungfern, wie es scheint. – "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Er will das\ngefüllte Wassergefäß aus Griseldas Hand entgegennehmen, die es ihm\nreicht.")]), _vm._v(" So! – brav! – Gehorsam geziemt der Leibeigenen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("gießt\nihm das Wasser über den Kopf.")]), _vm._v(" Werdet nüchtern, Herr\nMarkgraf, Ihr seid betrunken!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Graf Ulrich")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("hat\nGriselda blitzschnell an beiden Gelenken gefaßt.")]), _vm._v(" Was? Nun\nsollst du erfahren, daß ein Mann kein Weib und ein Weib kein\nMannsbild ist. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Er packt sie an und trägt sie\nins Haus.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Griselda")]), _vm._v(". Ich beiße, ich würge –\nich schlage Euch nieder! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Sie wird ins Haus\ngetragen, man hört beide herumpoltern.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Mutter Helmbrecht")]), _vm._v(". Das Mädel hat\nden Verstand verloren!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vater Helmbrecht")]), _vm._v(". Na ja! Und er und\nder alte Graf, die haben niemals, weiß Gott, welchen gehabt! "), _c('a', {
    staticClass: "pcalibre3 pcalibre pcalibre1 pcalibre2",
    attrs: {
      "id": "page13",
      "title": "joe_ebc/Pirki"
    }
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre10"
  }, [_c('li', {
    staticClass: "calibre11"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre pcalibre1 pcalibre2",
    attrs: {
      "href": "#/Text/#textAnno1",
      "id": "annotation1"
    }
  }, [_vm._v("Radwer")]), _vm._v(": Schubkarre")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0